var l = /* @__PURE__ */ ((n) => (n.PUT = "PUT", n.DELETE = "DELETE", n.GET = "GET", n.POST = "POST", n))(l || {});
async function m(n, t, e) {
  const s = new URL(t, e?.origin ?? window.location.origin);
  n === "GET" && (e?.data?.brand !== void 0 && ["+", "", "%2B", "None"].includes(e.data.brand) && delete e.data.brand, s.search = new URLSearchParams(e?.data).toString());
  let r = "same-origin";
  e?.mode && (r = e.mode);
  const o = await fetch(s.href, {
    method: n,
    mode: r,
    credentials: e?.credentials,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      ...e?.secureId ? { Authorization: `secure_id ${e.secureId}` } : null
    },
    ...n !== "GET" ? { body: JSON.stringify(e?.data) } : null
  });
  if (o.ok)
    return o.json();
  throw o;
}
class h {
  constructor(t, e) {
    this.value = t, this.expiryDate = e;
  }
}
const f = "_", E = 30 * 24 * 60 * 60;
class g {
  setItem(t, e, s = E) {
    const r = this.createExpiryDate(s).toJSON(), o = new h(e, r), d = JSON.stringify(o);
    localStorage.setItem(t, d);
  }
  getItem(t) {
    this.assertNotEmpty(t, "key");
    const e = this.getCacheEntry(t);
    if (e !== void 0) {
      if (e.expiryDate !== void 0 && this.isInThePast(new Date(e.expiryDate))) {
        this.removeItem(t);
        return;
      }
      return e.value;
    }
  }
  removeItem(t) {
    localStorage.removeItem(t);
  }
  removeAllItems() {
    localStorage.clear();
  }
  removeAllItemsWithKeyContainingString(t) {
    for (let e = localStorage.length - 1; e >= 0; e--) {
      const s = localStorage.key(e);
      s && s.indexOf(t) !== -1 && this.removeItem(s);
    }
  }
  removeExpiredItems() {
    const t = this.findExpiredKeys();
    this.removeItems(t);
  }
  getSize() {
    return localStorage.length;
  }
  createKey(t, e, ...s) {
    return this.assertNotEmpty(t, "domain"), this.assertNotEmpty(e, "moduleName"), [
      t,
      e,
      ...s.filter((r) => r !== void 0)
    ].map((r) => r.toLowerCase()).join(f);
  }
  getCacheEntry(t) {
    const e = localStorage.getItem(t);
    if (e !== null)
      try {
        return JSON.parse(e);
      } catch {
        return;
      }
  }
  removeItems(t) {
    for (const e of t)
      this.removeItem(e);
  }
  findExpiredKeys() {
    const t = [];
    for (let e = 0; e < localStorage.length; ++e) {
      const s = localStorage.key(e);
      if (s === null)
        continue;
      const r = this.getCacheEntry(s);
      r !== void 0 && this.isInThePast(new Date(r.expiryDate)) && t.push(s);
    }
    return t;
  }
  assertNotEmpty(t, e) {
    if (t.length === 0)
      throw new Error(`The ${e} must not be empty.`);
  }
  createExpiryDate(t) {
    const e = new Date();
    return e.setSeconds(e.getSeconds() + t), e;
  }
  isInThePast(t) {
    return new Date() > t;
  }
}
var u = /* @__PURE__ */ ((n) => (n.Foundation = "foundation", n))(u || {});
const y = new g();
function a() {
  return y;
}
const I = 24 * 60 * 60;
function S(n, t, e) {
  a().setItem(
    i(t, e),
    n,
    I
  );
}
function L() {
  a().removeAllItemsWithKeyContainingString(i());
}
function p(n, t) {
  return a().getItem(i(n, t));
}
function i(n, t) {
  return a().createKey(
    u.Foundation,
    "user",
    "licenses",
    n,
    t
  );
}
function v(n, t, e) {
  return n.some(
    (s) => c(s.productCode, t) && c(s.countryCode, e) && new Date(s.expiration) > new Date()
  );
}
function c(n, t) {
  return n.toLowerCase() === t.toLowerCase();
}
const w = "/api/foundation/user/v1/";
async function T(n, t, e = !1) {
  if (e) {
    const r = p(n, t);
    if (r !== void 0)
      return {
        succeeded: !0,
        result: r,
        errors: []
      };
  }
  const s = await m(
    l.GET,
    `${w}user-licenses`,
    {
      data: {
        productCode: n,
        countryCode: t
      }
    }
  );
  return e && s.succeeded && S(
    s.result,
    n,
    t
  ), s;
}
async function D(n, t, e = !1) {
  const s = await T(n, t, e);
  return s.succeeded ? v(
    s.result,
    n,
    t
  ) : !1;
}
export {
  L as clearUserLicensesInCache,
  T as getUserLicense,
  D as isUserLicensed
};
//# sourceMappingURL=index.js.map
